export default __webpack_public_path__ + "static/media/dog.8cad9d5c.png";